import Icon, { ICONSIZE } from '../../../../../../../presentation/components/Icon';
import screenIcon from '../../../../../../assets/icons/png/3x/icn-bildschirm@3x-schwarz.png';
import checkmarkIcon from '../../../../../../assets/icons/png/3x/circle-check-info@3x.png';
import TableEntry from '../../TableEntry';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';

const CustomerPortal = () => {
  const isAboveXXS = useMediaQuery('(min-width: 376px)');
  const { t } = useTranslation();

  return (
    <TableEntry
      leftValues={[
        t('pageSummaryBasicServicesSectionLabelCustomerPortalAccessTitle'),
        t('pageSummaryBasicServicesSectionLabelCustomerPortalAccessContent')
      ]}
      startElement={<Icon iconSrc={screenIcon} size={ICONSIZE.medium} alt="customer portal icon" />}
      endElement={
        <Icon iconSrc={checkmarkIcon} size={ICONSIZE.small} centered alt="checkmark icon" />
      }
      additionalClassNames={isAboveXXS ? '' : 'px-0'}
    />
  );
};

export default CustomerPortal;
